module.exports = __webpack_public_path__ + "static/media/del_icon.346c3dad.svg";